import {FC, ReactNode} from 'react'
import {Navigate} from 'react-router-dom'
import {useUser} from '../../contexts/UserContext'
import {hasRoleAccess} from './utils/roleHierarchy'
import type {UserRole} from '../../types/auth'

interface RoleProtectedRouteProps {
  children: ReactNode;
  requiredRole?: UserRole;
  fallback?: ReactNode;
  redirectTo?: string;
}

const RoleProtectedRoute: FC<RoleProtectedRouteProps> = ({
  children,
  requiredRole,
  fallback = null,
  redirectTo = '/dashboard'
}) => {
  const {user} = useUser()

  if (!user) {
    return <Navigate to="/" replace/>
  }

  if (!requiredRole) {
    return <>{children}</>
  }

  const userRoles = user.roles || []
  const hasAccess = hasRoleAccess(userRoles, requiredRole)

  if (!hasAccess) {
    if (fallback) {
      return <>{fallback}</>
    }

    return <Navigate to={redirectTo} replace/>
  }

  return <>{children}</>
}

export default RoleProtectedRoute
